@if (overlay) {
  <div class="overlay" role="status" aria-live="polite" aria-label="Loading">
    <div class="loader">
      <span class="ring ring-outer"></span>
      <span class="ring ring-inner"></span>
      <span class="dot"></span>
    </div>
  </div>
}
